/* default formatter for character count used in Textarea/textfield */
export const defaultNumberFormatter = (value: number) => {
  return value.toString();
};
